import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { configurations } from '../../api'
import WebWidgetCreator from './WebWidgetCreator'
import WebWidgetEdit from './WebWidgetEdit'
import ModalWrapper from 'components/ModalWrapper'
import { getStaticImage } from 'utils/statics'

const WebWidgetCreatorModal = (props) => {
  const { channels, createWebWidget, dataCloneQrToWebWidget, onDataWidgetToQR, onClose } = props
  const channelsApi = configurations.channels
  const [currentTab, setCurrentTab] = React.useState(0)
  const [widgets, setWidgets] = React.useState([])

  React.useEffect(() => {
    if (dataCloneQrToWebWidget) {
      setCurrentTab(0)
    }
  }, [dataCloneQrToWebWidget])

  const handleCurrentTab = (idx) => {
    setCurrentTab(idx)
  }

  const getAllWebWidget = async () => {
    try {
      const result = await channelsApi.getAllWebWidget()
      if (result.data.length) {
        setWidgets(result.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const tabs = [
    {
      name: I18n.t('channels_widget_new'),
      body: <WebWidgetCreator
        key='WebWidgetCreator'
        channels={channels}
        createWebWidget={createWebWidget}
        getAllWebWidgetExternal={getAllWebWidget}
        dataCloneQrToWebWidget={dataCloneQrToWebWidget}
      />
    },
    {
      name: I18n.t('channels_widget_edit'),
      body: <WebWidgetEdit
        key='WebWidgetEdit'
        channels={channels}
        createWebWidget={createWebWidget}
        widgets={widgets}
        getAllWebWidgetExternal={getAllWebWidget}
        onDataWidgetToQR={onDataWidgetToQR}
      />
    }
  ]

  const body = (
    <div className={'ww-tabs-container'}>
      <div className={'ww-tabs-buttons'}>
        {tabs.map((it, idx) => (
          <div key={idx}>
            <div className={`ww-tab-button ${currentTab === idx && 'active'}`} onClick={() => handleCurrentTab(idx)}>
              <span className='ww-tab-text'>{it.name}</span>
            </div>
          </div>
        ))}
        <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' onClick={onClose} className='close-button' />
      </div>
      <div className='ww-tabs-body animated fadeIn'>
        {tabs.length > 0 ? tabs[currentTab].body : null}
      </div>
    </div>
  )

  return (
    <ModalWrapper
      id={'modalWebWidgetWrapper'}
      body={body}
      isOpen={props.isOpen}
      toggle={onClose}
    />
  )
}

export default WebWidgetCreatorModal
